import { render } from "./EditLangItem.vue?vue&type=template&id=79279a1c&scoped=true&ts=true"
import script from "./EditLangItem.vue?vue&type=script&lang=ts"
export * from "./EditLangItem.vue?vue&type=script&lang=ts"

import "./EditLangItem.vue?vue&type=style&index=0&id=79279a1c&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79279a1c"]])

export default __exports__